module.exports = __webpack_public_path__ + "img/404.f1f59d7c.png";